export const APP_VERSION = "Version: abp_master_20260915.13";
